import {Injectable} from '@angular/core';
import {switchMap} from 'rxjs/operators';
import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import {KeycloakService} from 'keycloak-angular';
import {from} from 'rxjs';
import {AuthStateService} from "./auth-state.service";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    constructor(private keycloak: KeycloakService,
                private authState: AuthStateService) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler) {
        return this.authState.waitUntilReady().pipe(
            switchMap(isLogged => {
                if (!isLogged) {
                    return next.handle(req);
                }

                return from(this.keycloak.getToken()).pipe(
                    switchMap(token => {
                        const authReq = req.clone({
                            setHeaders: {
                                Authorization: 'Bearer ' + token
                            }
                        });
                        return next.handle(authReq);
                    })
                );
            })
        );
    }
}
